import React, { Component } from 'react';
import { HeaderMain } from '../../Common/HeaderMain'
import { HeaderSub } from '../../Common/HeaderSub'
import { BoorkMarkGoods } from './BoorkMarkGoods';
import { BoorkMarkStore } from './BoorkMarkStore';
import { Footer } from '../../Common/Footer'
import { StoreDtl } from '../../Search/Store/StoreDtl';
import { GoodsDtl } from '../../Search/Goods/GoodsDtl';
import { GoodsZoom } from '../../Search/Goods/GoodsZoom';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.BoorkMarkGoods,  //기본 컴포넌트 할당
            ContentState: null
        };
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    //호출할 컴포넌트 이름
    CompName = {
        "BoorkMarkGoods": "BoorkMarkGoods",
        "BoorkMarkStore": "BoorkMarkStore",
        "GoodsDtl": "GoodsDtl",
        "StoreDtl": "StoreDtl",
        "GoodsZoom": "GoodsZoom"
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.BoorkMarkGoods) {
            return (
                <div>
                    <HeaderMain
                        HeaderSub={{ Title: "찜", LinkYn: "N", LinkUrl: "", ComponentUrl: "" }}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                    <BoorkMarkGoods
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.BoorkMarkStore) {
            return (
                <div>
                    <HeaderMain
                        HeaderSub={{ Title: "찜", LinkYn: "N", LinkUrl: "", ComponentUrl: "BoorkMarkGoods" }}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                    <BoorkMarkStore
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <Footer fillName="icon3" />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreDtl) {
            //매장상세
            return (
                <div>
                    <StoreDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsDtl) {
            //상품상세
            return (
                <div>
                    <GoodsDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsZoom) {
            //상품상세
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="상세이미지"
                        ComponentUrl="GoodsDtl"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsZoom
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            );
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
